import {
  ensureGeneralLibrary,
  pollDocumentUntilDone,
  uploadDocument,
} from "@/apps/rag/api/rag-api";
import type { SupervisorAttachment } from "../components/SupervisorThread";

export { isContractReviewAttachmentIntent } from "./contract-review-attachment-intent";

export function fileFromSupervisorAttachment(attachment: SupervisorAttachment): File {
  const comma = attachment.dataUrl.indexOf(",");
  const base64 = comma >= 0 ? attachment.dataUrl.slice(comma + 1) : attachment.dataUrl;
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], attachment.name, {
    type: attachment.mediaType || "application/octet-stream",
  });
}

/**
 * Upload a General Chat attachment into the user's persistent general library
 * and wait until RAG processing completes.
 */
export async function uploadGeneralChatAttachment(
  attachment: SupervisorAttachment,
): Promise<{ libraryId: string; documentId: string }> {
  const { library } = await ensureGeneralLibrary();
  const file = fileFromSupervisorAttachment(attachment);
  const title = attachment.name.replace(/\.[^/.]+$/, "") || attachment.name;
  const { document } = await uploadDocument(library.id, file, title);
  const status = await pollDocumentUntilDone(document.id);
  if (status === "FAILED") {
    throw new Error("Document processing failed. Try uploading again.");
  }
  if (status !== "COMPLETED") {
    throw new Error("Document processing did not finish. Try again.");
  }
  return { libraryId: library.id, documentId: document.id };
}
